import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const interestService = {
  getAllInstructor,
  addInstructor,
  getInstructor,
  deleteInstructor
};

function getAllInstructor(params) {
  return apiCall("GET", apiUrls.instructors.base, null, params);
}

function addInstructor(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.instructors.base;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getInstructor(id) {
  return apiCall("GET", `${apiUrls.instructors.base}/${id}`);
}

function deleteInstructor(id) {
  return apiCall("DELETE", `${apiUrls.instructors.base}/${id}`);
}
